import {Injectable} from '@angular/core';
import {IService} from '../IService';
import {PromotionCampaignDetailModel} from '../../models/promotion-campaign.model';
import {HttpClientService} from '../httpClient/httpclient.service';

@Injectable()
export class PromotionCampaignDetailService extends IService<PromotionCampaignDetailModel> {

  constructor(
    http: HttpClientService
  ) {
    super(http, 'koncentro-promo', 'campaign-detail')
  }


}



// WEBPACK FOOTER //
// ./src/app/services/promotion/promotion-campaign-detail.service.ts